function startDateMs(batch) {
  const t = Date.parse(String(batch?.startDate ?? '').slice(0, 10));
  return Number.isFinite(t) ? t : 0;
}

/** Nearest upcoming `startDate` first — admin event date pickers (Registrations, etc.). */
export function sortEventBatchesByStartDateAsc(batches) {
  if (!Array.isArray(batches)) return [];
  return [...batches].sort((a, b) => startDateMs(a) - startDateMs(b));
}

/** Latest `startDate` first — lists that default to newest batch on top. */
export function sortEventBatchesByStartDateDesc(batches) {
  if (!Array.isArray(batches)) return [];
  return [...batches].sort((a, b) => startDateMs(b) - startDateMs(a));
}
